import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M4 3a2 2 0 0 0-2 2v3h26V7a2 2 0 0 0-2-2H11.2l-.618-1.03A2 2 0 0 0 8.867 3zm-1 7a1 1 0 0 0-1 1v12a2 2 0 0 0 2 2h22a2 2 0 0 0 2-2V11a1 1 0 0 0-1-1z" }, null, -1)
  ]))]))
}
export default { render: render }